import { BillingCycle, MarketingPlan, PlanPricing } from '../types/pricing';

export const BILLING_CYCLES: { key: BillingCycle; label: string }[] = [
  { key: 'monthly', label: 'Monthly' },
  { key: 'quarterly', label: 'Quarterly' },
  { key: 'yearly', label: 'Yearly' },
];

export function formatInr(amount: number | undefined | null): string {
  if (amount == null || Number.isNaN(amount)) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
}

export function priceForCycle(
  tier: { pricing?: PlanPricing[] },
  cycle: BillingCycle
): PlanPricing | undefined {
  return tier.pricing?.find((p) => p.billingCycle === cycle);
}

export function cycleSuffix(cycle: BillingCycle): string {
  if (cycle === 'yearly') return '/ year';
  if (cycle === 'quarterly') return '/ quarter';
  return '/ month';
}

export function lowestPriceForPlan(plan: MarketingPlan, cycle: BillingCycle = 'monthly'): number | null {
  if (plan.contactOnly || plan.customizable) return null;
  let min: number | null = null;
  for (const tier of plan.tiers || []) {
    const row = priceForCycle(tier, cycle);
    if (row?.priceInr != null && !Number.isNaN(row.priceInr)) {
      if (min == null || row.priceInr < min) min = row.priceInr;
    }
  }
  return min;
}

export function lowestPriceAcrossPlans(plans: MarketingPlan[], cycle: BillingCycle = 'monthly'): number | null {
  let min: number | null = null;
  for (const plan of plans) {
    const p = lowestPriceForPlan(plan, cycle);
    if (p != null && (min == null || p < min)) min = p;
  }
  return min;
}

export function planStartingPriceLabel(plan: MarketingPlan, cycle: BillingCycle = 'monthly'): string | null {
  const price = lowestPriceForPlan(plan, cycle);
  if (price == null) return null;
  return formatInr(price);
}

export function footerPricingSummary(plans: MarketingPlan[]): string | null {
  if (!plans.length) return null;
  const parts = plans
    .map((plan) => {
      if (plan.contactOnly || plan.customizable) return null;
      const from = planStartingPriceLabel(plan);
      if (!from) return null;
      return `${plan.name} from ${from}/mo`;
    })
    .filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
}
